import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function list(page, params) {
  return request({
    url: `/treatment-group/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params: params
  });
}

function all() {
  return request({
    url: '/treatment-group/all',
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function save(values) {
  return request({
    url: '/treatment-group/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data: values
  });
}

function update(id, values) {
  return request({
    url: `/treatment-group/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data: values
  });
}

function find(id) {
  return request({
    url: `/treatment-group/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function remove(id) {
  return request({
    url: `/treatment-group/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

const TreatmentGroupService = {
  list, all, save, update, find, remove
}

export default TreatmentGroupService;
